import {
  CurrentIncentivesResultTypenames,
  IncentiveCategory,
  IncentiveCategoryInput,
  Query,
  QueryCurrentIncentivesArgs,
} from '@varo/graphql-schema-types';
import CurrentIncentives from 'services/graphql/queries/Incentive/CurrentIncentives';
import { useQuery } from 'urql';

const INCENTIVE_CATEGORY_INPUTS: Record<
  IncentiveCategory,
  IncentiveCategoryInput
> = {
  [IncentiveCategory.Sweepstakes]: IncentiveCategoryInput.Sweepstakes,
};

const useCurrentIncentives = (incentiveType: IncentiveCategory) => {
  const [{ data, fetching, error }, reexecuteQuery] = useQuery<
    Query,
    QueryCurrentIncentivesArgs
  >({
    query: CurrentIncentives,
    variables: {
      input: { incentiveType: INCENTIVE_CATEGORY_INPUTS[incentiveType] },
    },
    requestPolicy: 'cache-and-network',
  });

  const result = data?.currentIncentives;
  const incentives =
    result?.__typename ===
    CurrentIncentivesResultTypenames.CurrentIncentivesSuccess
      ? result.incentives
      : undefined;
  const incentivesError =
    result?.__typename ===
    CurrentIncentivesResultTypenames.CurrentIncentivesError
      ? result
      : undefined;

  const refresh = () => {
    reexecuteQuery({ requestPolicy: 'network-only' });
  };

  return { incentives, fetching, error, incentivesError, refresh };
};

export default useCurrentIncentives;
